import qs from "qs";
import React, { useState, useReducer, useEffect, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import { BandsContext } from "../../../utils/stateHandlers/contexts";
import {
  Box,
  Button,
  Chip,
  Skeleton,
  Step,
  Stepper,
  Stack,
  Typography,
  StepContent,
  StepLabel,
} from "@mui/material";
import { bandsReducer } from "../../../utils/stateHandlers/reducers";
import BandsFields from "../components/bandsComponents/BandsFields";
import BandsSpecialInstructions from "../components/bandsComponents/BandsSpecialInstructions";
import CheckIcon from "@mui/icons-material/Check";
import { api, functions } from "../../../utils";
import formatting from "../../../utils/formatHelpers";
import diamondPlaceHolder from "../../../assets/images/icons/icon-HS-sig.png";
import states from "../../../utils/stateHandlers/initialStates";

let steps = ["Band Details", "Ring Treatments"];
let stepCounter = 0;
const numberStringName = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

function BandStepper({
  builder,
  complex,
  complex1,
  complex2,
  complex3,
  product,
  stoneProviderFlag,
  productInfo,
  resetSelection,
  setSettingModalOpen,
  diamondSelected,
  isBuilder,
  setting,
  globalStepperActiveStep,
  globalStepperBack,
  globalStepperNext,
  globalStepperReset,
  resetDiamond,
  activeBandStep,
  setActiveBandStep,
  isCoreStyle,
}) {
  //  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const theme = useTheme();
  const [loadingSetting, setLoadingSetting] = useState(false);
  const [loadingDiamond, setLoadingDiamond] = useState(false);
  const { bandsState } = useContext(BandsContext);
  const { priceLoaded, productDetails } = bandsState;
  //  const [heightValues, setHeightValues] = useState();

  const [bubbles, setStrapiInfoBubbles] = useState(false);

  const formerStylesField = productDetails
    .filter((element) => element.label == "Former Style")
    .map((formerStyle) => formerStyle.value);

  const heightField = complex1.filter(
    (element) => element.label == "Height (mm)"
  );

  const heightValues =
    heightField.length > 0
      ? heightField[0].values.map((formerStyle) => formerStyle.value)
      : [];

  useEffect(() => {
    if (product == "A") {
      const query = qs.stringify({
        populate: {
          Product: {
            populate: "*",
          },
          bubble: {
            populate: "*",
          },
        },
      });
      api.fetchStrapi(`/info-bubbles/2?${query}`).then((response) => {
        setStrapiInfoBubbles(response.data.data.attributes.bubble);
      });
    }
  }, [product]);

  useEffect(() => {
    if (product == "W") {
      if (formerStylesField.length > 0) {
        //        setHeightValues(heightField[0].values.length);
      }
    }
  }, [formerStylesField]);

  useEffect(() => {
    if (productInfo["complex[1][band][material]"] === "STR") {
      resetSelection("S");
    }
  }, [productInfo["complex[1][band][material]"]]);

  useEffect(() => {
    if (productInfo["builder[quantity]"] > 1) {
      resetDiamond();
    }
  }, [productInfo["builder[quantity]"]]);

  useEffect(() => {
    steps = ["Band Details", "Ring Treatments"];
    if (product === "A") {
      var stepIndexInsert = 1;
      steps.splice(stepIndexInsert, 0, "Stone Details");
    }
    if (isBuilder) {
      steps.push("Choose a Setting (Optional)");
      steps.push("Choose Center Stone (Optional)");
    }
  }, [isBuilder]);

  const fieldMap = {
    materialField: complex1.find((item) => item.label === "Material"),
    ringSizeField: complex.find((item) => item.label === "Ring Size"),
    stoneSizeField: complex1.find(
      (item) => item.label === "Stone Size (ct - mm)"
    ),
    stoneQuantityField: complex1.find(
      (item) => item.label === "Stone Quantity"
    ),
    widthField: complex1.find((item) => item.label === "Width (mm)"),
    heightField: complex1.find((item) => item.label === "Height (mm)"),
    stoneProviderField: complex1.find(
      (item) => item.label === "Stone Provided By"
    ),
    stoneQualityField: complex1.find(
      (item) => item.label === "Stone Quality and Type"
    ),
    finishField: complex1.find((item) => item.label === "Finish"),
    rhodiumPlatingField: complex1.find(
      (item) => item.label === "Rhodium Plating"
    ),
    karatStampField: complex.find((item) => item.label === "Karat Stamp"),
    trademarkField: complex.find((item) => item.label === "Trademark"),
    stoneSpreadField: complex1.find((item) => item.label === "Diamond Spread"),
    endTypeField: complex1.find((item) => item.label === "Ends"),
    fitTypeField: complex1.find((item) => item.label === "Fit Type"),
    drillTypeField: complex1.find((item) => item.label === "Drill Type"),
    caratSettingField: complex1.find((item) => item.label === "Drill Type"),
    drillTypeField: complex1.find((item) => item.label === "Drill Type"),
  };

  const fieldMap2 = {
    materialField: complex2.find((item) => item.label === "Material"),
    ringSizeField: complex.find((item) => item.label === "Ring Size"),
    stoneSizeField: complex.find(
      (item) => item.label === "Stone Size (ct - mm)"
    ),
    stoneQuantityField: complex2.find(
      (item) => item.label === "Stone Quantity"
    ),
    widthField: complex2.find((item) => item.label === "Width (mm)"),
    heightField: complex2.find((item) => item.label === "Height (mm)"),
    stoneProviderField: complex2.find(
      (item) => item.label === "Stone Provided By"
    ),
    stoneQualityField: complex2.find(
      (item) => item.label === "Stone Quality and Type"
    ),
    finishField: complex2.find((item) => item.label === "Finish"),
    rhodiumPlatingField: complex2.find(
      (item) => item.label === "Rhodium Plating"
    ),
    karatStampField: complex.find((item) => item.label === "Karat Stamp"),
    trademarkField: complex.find((item) => item.label === "Trademark"),
    stoneSpreadField: complex2.find((item) => item.label === "Diamond Spread"),
    endTypeField: complex2.find((item) => item.label === "Ends"),
    fitTypeField: complex2.find((item) => item.label === "Fit Type"),
    drillTypeField: complex2.find((item) => item.label === "Drill Type"),
    caratSettingField: complex2.find((item) => item.label === "Drill Type"),
    drillTypeField: complex2.find((item) => item.label === "Drill Type"),
  };

  const getDefaultValue = (complexArray, label) => {
    const item = complexArray.find((item) => item.label === label);
    if (!item) return null;

    const defaultValue = String(item.default ?? "");
    if (label === "Quantity") {
      return defaultValue;
    }
    const defaultLabel = item.values?.find(
      (val) => String(val.value) === defaultValue
    );
    return String(defaultLabel?.label ?? "");
  };

  const fieldSelected = {
    0: {
      Qty: `${productInfo["builder[quantity]"]} ${productInfo["builder[quantity_unit]"]}`,
      Material: productInfo["complex[1][band][material]"],
      "Ring Size": productInfo["complex[finger_size]"],
    },
    1: {
      "Stone Size": `${productInfo["complex[1][1][1][size]"]} ct`,
      Qty: productInfo["complex[1][1][1][quantity]"],
      Provider: productInfo["complex[1][1][1][source]"],
      Quality:
        productInfo["complex[1][1][1][source]"] === "H&S"
          ? getDefaultValue(complex1, "Stone Quality and Type")
          : "None",
    },
    2: {
      Finish: [
        productInfo["complex[1][band][finish]"] === "U"
          ? "Unfinished"
          : "Hand Polish",
        productInfo["complex[1][band][rhodium]]"] === "Y" ? "Rhodium" : null,
        productInfo["complex[karat_stamp]"] === "Y" ? "Karat Stamp" : null,
        productInfo["complex[trademark]"] === "Y" ? "Trademark" : null,
      ]
        .filter(Boolean) // Remove null values
        .join(", "), // Convert array to string with comma separation
    },
    3: {
      Setting:
        productInfo["setting[product]"] + productInfo["setting[dimension]"],
      "Setting Size": `${productInfo["setting[carat_size]"]} ct`,
      Material: productInfo["setting[material]"],
    },
    4: {
      Diamond: `${
        diamondSelected.MinedOrLab === "M"
          ? "Mined Diamond"
          : "Lab-Grown Diamond"
      } ${diamondSelected.Carat}ct ${diamondSelected.Shape} ${
        diamondSelected.Color
      } ${diamondSelected.Clarity} ${diamondSelected.HooverCertification}`,
    },
  };

  const handleNext = () => {
    setCompletedSteps((prev) => new Set([...prev, activeBandStep]));
    setActiveBandStep((prev) => prev + 1);
    if (activeBandStep == 2 && globalStepperActiveStep == 0) {
      globalStepperNext(true);
    }
  };

  const handleCompleteStep = () => {
    setCompletedSteps((prev) => new Set([...prev, activeBandStep]));
  };

  const handleBack = () => {
    setCompletedSteps((prev) => {
      const newSet = new Set(prev);
      newSet.delete(activeBandStep - 1);
      return newSet;
    });
    setActiveBandStep((prev) => prev - 1);
    if (activeBandStep == 3 && globalStepperActiveStep == 1) {
      globalStepperBack();
    }
  };

  const handleReset = () => {
    setActiveBandStep(0);
    setCompletedSteps(new Set());
    resetSelection("S");
    // Issue with resetdiamond code running
    globalStepperReset();
  };

  const handleStepperClick = (index) => {
    if (
      product == "A"
        ? index != 4 ||
          (index == 4 && setting.style && productInfo["setting[carat_size]"])
        : index != 3 || (index == 3 && setting.style)
    ) {
      setActiveBandStep(index);
    }
  };

  const LoadingSkeleton = () => (
    <Stack direction="row" spacing={2}>
      <Skeleton variant="rectangular" width={90} height={90} />
      <Stack>
        <Skeleton variant="text" sx={{ fontSize: "2rem" }} width="25rem" />
        <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
      </Stack>
      <Skeleton variant="rectangular" width={30} height={30} />
    </Stack>
  );

  const Settings = () => (
    <>
      <Stack spacing={1} sx={{ marginTop: "3rem" }}>
        <Stack
          direction="row"
          sx={{
            backgroundColor: "#cfdde9",
          }}
          alignItems="center"
        >
          <Typography variant="h2" sx={{ width: "100%" }}>
            Setting
          </Typography>
          {setting && setting.style ? (
            <Chip
              className="float-right"
              color="warning"
              //              disabled={activeStep == 3}
              label="Reset Selection"
              onClick={() => resetSelection("S")}
              sx={{ marginRight: "1rem" }}
            />
          ) : (
            <Chip
              label="Pick A New Setting"
              //                disabled={!authToken}
              variant="outlined"
              className="float-right"
              color="primary"
              sx={{ marginRight: "1rem" }}
              onClick={() => setSettingModalOpen(true)}
            />
          )}
        </Stack>
        {loadingSetting ? (
          LoadingSkeleton()
        ) : (
          <Stack direction="row" spacing={2}>
            {setting && setting.style && (
              <img
                src={setting.images[0]}
                className="detail-imgs"
                alt="Mini Product"
                onError={(e) => {
                  e.target.src = diamondPlaceHolder;
                }}
              />
            )}
            <Stack spacing={2}>
              <Typography>
                Current Setting:{" "}
                {setting && setting.style ? setting.style : "None Selected"}
              </Typography>
              <Typography>{`${formatting["decodeHtml"](
                setting.description
              )}`}</Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              {setting &&
                setting.icons &&
                setting.icons.map((icons, key) => (
                  <Typography key={icons} className="icons">
                    {functions.getIcons(icons)}
                  </Typography>
                ))}
            </Stack>
          </Stack>
        )}
        <Stack spacing={3} sx={{ marginTop: "2rem" }}>
          {setting &&
            setting.settingFields?.map((field, index) => (
              <React.Fragment key={index}>
                {(() => {
                  field.default = productInfo[field.name]
                    ? productInfo[field.name]
                    : field.default;
                  return null;
                })()}
                {field.name !== "quantity" && (
                  <BandsFields
                    field={field}
                    locked={
                      diamondSelected && field.name == "setting[carat_size]"
                    }
                  />
                )}
              </React.Fragment>
            ))}
        </Stack>
      </Stack>
    </>
  );

  const Diamonds = () => (
    <>
      <Stack spacing={1} sx={{ marginTop: "3rem" }}>
        <Stack
          direction="row"
          sx={{
            backgroundColor: "#cfdde9",
          }}
          alignItems="center"
        >
          <Typography variant="h2" sx={{ width: "100%" }}>
            Diamond
          </Typography>
          {diamondSelected ? (
            <Chip
              className="float-right"
              color="warning"
              label="Reset Selection"
              onClick={() => resetDiamond()}
              sx={{ marginRight: "1rem" }}
            />
          ) : (
            <Chip
              label="Pick A New Diamond"
              variant="outlined"
              className="float-right"
              color="primary"
              sx={{ marginRight: "1rem" }}
              onClick={() => callDiamondSelect()}
            />
          )}
        </Stack>
        {loadingDiamond ? (
          LoadingSkeleton()
        ) : (
          <Stack direction="row" spacing={2}>
            {diamondSelected && (
              <img
                src={diamondSelected.ImageLink}
                className="detail-imgs"
                alt="Mini Product"
                onError={(e) => {
                  e.target.src = diamondPlaceHolder;
                }}
              />
            )}
            <Stack spacing={2}>
              <Typography>
                Current Diamond:{" "}
                {diamondSelected
                  ? diamondSelected.HooverStockId +
                    " " +
                    (diamondSelected.MinedOrLab === "M"
                      ? "Mined Diamond"
                      : "Lab-Grown Diamond")
                  : "None Selected"}
              </Typography>
              <Typography>
                {diamondSelected
                  ? `${formatting["decodeHtml"](
                      `${diamondSelected.Carat}ct ${diamondSelected.Shape} ${diamondSelected.Color} ${diamondSelected.Clarity} ${diamondSelected.HooverCertification}`
                    )}`
                  : ""}
              </Typography>
            </Stack>
          </Stack>
        )}
      </Stack>
    </>
  );

  function callDiamondSelect() {
    globalStepperNext(true);
  }

  function formatListWithAnd(arr, isHeight = false) {
    if (arr.length === 0) {
      return "";
    } else if (arr.length === 1) {
      return arr[0] + (isHeight ? "MM" : "");
    } else {
      // Get all but the last element and join with a comma and space
      const allButLast = isHeight
        ? arr.slice(0, -1).join("MM, ")
        : arr.slice(0, -1).join(", ");
      // Get the last element
      const last = arr[arr.length - 1];
      // Combine them with " and "
      return isHeight
        ? `${allButLast}MM, and ${last}MM`
        : `${allButLast}, and ${last}`;
    }
  }

  function formatBubbleText() {
    var heightInfoBubbleText =
      "The " +
      productInfo["builder[product]"] +
      productInfo["builder[dimension]"] +
      " is offered in " +
      formatListWithAnd(heightValues, true) +
      " heights. This core style replaces former styles " +
      formatListWithAnd(
        formerStylesField.map((s) => s.split(" ")[0]),
        false
      ) +
      ". These former styles are noted in the details box with their MM heights for your reference. Be sure to select" +
      " your preferred height from the dropdown menu when placing your order";
    return heightInfoBubbleText;
  }

  const renderStepContent = (activeBandStep) => (
    <Stack spacing={2}>
      {/* Step 0 */}
      <Box sx={{ display: activeBandStep === 0 ? "block" : "none" }}>
        {fieldMap.materialField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.materialField} />
          </Box>
        )}
        {builder?.map((field) => (
          <Box key={field.name} sx={{ mb: 2 }}>
            <BandsFields
              field={field}
              locked={diamondSelected && field.label == "Quantity"}
            />
          </Box>
        ))}
        {fieldMap.ringSizeField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.ringSizeField} />
          </Box>
        )}
        {product !== "A" && fieldMap.heightField && (
          <Box sx={{ mb: 2 }}>
            {isCoreStyle &&
            heightValues.length > 0 &&
            formerStylesField.length > 0 ? (
              <BandsFields
                field={fieldMap.heightField}
                bubbles={{
                  bubblefield: "FormerStyleInfo",
                  bubbleimage: {
                    data: null,
                  },
                  bubbletext: formatBubbleText(),
                  bubbletitle:
                    "This Core Style is Available in " +
                    numberStringName[heightValues.length] +
                    " Heights",
                  id: 18,
                }}
              />
            ) : (
              <BandsFields field={fieldMap.heightField} />
            )}
          </Box>
        )}
        {product !== "A" && fieldMap.widthField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.widthField} />
          </Box>
        )}
      </Box>

      {/* Step 1 */}
      <Box
        sx={{
          display: product == "A" && activeBandStep === 1 ? "block" : "none",
        }}
      >
        {fieldMap.stoneSizeField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.stoneSizeField} />
          </Box>
        )}
        {fieldMap.stoneSpreadField && (
          <Box sx={{ mb: 2 }}>
            {bubbles ? (
              <BandsFields
                field={fieldMap.stoneSpreadField}
                bubbles={
                  bubbles.filter(
                    (bubble) => bubble.bubbletitle === "Diamond Spread"
                  )[0]
                }
              />
            ) : (
              <BandsFields field={fieldMap.stoneSpreadField} />
            )}
          </Box>
        )}
        {fieldMap2.stoneQuantityField ? (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap2.stoneQuantityField} />
          </Box>
        ) : fieldMap.stoneQuantityField ? (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.stoneQuantityField} />
          </Box>
        ) : null}
        {fieldMap.drillTypeField && (
          <Box sx={{ mb: 2 }}>
            {bubbles ? (
              <BandsFields
                field={fieldMap.drillTypeField}
                bubbles={
                  bubbles.filter(
                    (bubble) => bubble.bubbletitle === "Drill Type"
                  )[0]
                }
              />
            ) : (
              <BandsFields field={fieldMap.drillTypeField} />
            )}
          </Box>
        )}
        {fieldMap.endTypeField && (
          <Box sx={{ mb: 2 }}>
            {bubbles ? (
              <BandsFields
                field={fieldMap.endTypeField}
                bubbles={
                  bubbles.filter(
                    (bubble) => bubble.bubbletitle === "End Type"
                  )[0]
                }
              />
            ) : (
              <BandsFields field={fieldMap.endTypeField} />
            )}
          </Box>
        )}
        {fieldMap.stoneProviderField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.stoneProviderField} />
          </Box>
        )}
        {stoneProviderFlag && fieldMap.stoneQualityField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.stoneQualityField} />
          </Box>
        )}
      </Box>

      {/* Step 2 */}
      <Box
        sx={{
          display: (
            product == "A" ? activeBandStep === 2 : activeBandStep === 1
          )
            ? "block"
            : "none",
        }}
      >
        {fieldMap.finishField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.finishField} />
          </Box>
        )}
        {fieldMap.fitTypeField && (
          <Box sx={{ mb: 2 }}>
            {bubbles ? (
              <BandsFields
                field={fieldMap.fitTypeField}
                bubbles={
                  bubbles.filter(
                    (bubble) => bubble.bubbletitle === "Fit Type"
                  )[0]
                }
              />
            ) : (
              <BandsFields field={fieldMap.fitTypeField} />
            )}
          </Box>
        )}
        {fieldMap.rhodiumPlatingField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.rhodiumPlatingField} />
          </Box>
        )}
        {fieldMap.karatStampField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.karatStampField} />
          </Box>
        )}
        {fieldMap.trademarkField && (
          <Box sx={{ mb: 2 }}>
            <BandsFields field={fieldMap.trademarkField} />
          </Box>
        )}
        <Box sx={{ mb: 2 }}>
          <BandsSpecialInstructions />
        </Box>
      </Box>

      {/* Step 3 */}
      <Box
        sx={{
          display: (
            product == "A" ? activeBandStep === 3 : activeBandStep === 2
          )
            ? "block"
            : "none",
        }}
      >
        {Settings()}
        {/*  Old code
        {complex2?.map((field) => (
          <Box key={field.name} sx={{ mb: 2 }}>
            <BandsFields field={field} />
          </Box>
        ))}
          */}
      </Box>

      {/* Step 4 */}
      <Box
        sx={{
          display: (
            product == "A" ? activeBandStep === 4 : activeBandStep === 3
          )
            ? "block"
            : "none",
        }}
      >
        {Diamonds()}
        {/* Old Code
        complex3?.map((field) => (
          <Box key={field.name} sx={{ mb: 2 }}>
            <BandsFields field={field} />
          </Box>
        ))}
          */}
      </Box>
    </Stack>
  );

  const CustomStepIcon = ({ icon, active }) => {
    const isCompleted = completedSteps.has(icon - 1);
    return (
      <Box
        sx={{
          width: 30,
          height: 30,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
          backgroundColor: isCompleted
            ? theme.palette.success.main
            : active
            ? theme.palette.primary.main
            : theme.palette.secondary.dark,
          color: theme.palette.primary.contrastText,
          fontSize: "1.5rem",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {isCompleted ? <CheckIcon /> : icon}
      </Box>
    );
  };

  return (
    <Box>
      <Stepper nonLinear activeStep={activeBandStep} orientation="vertical">
        {steps.map((label, index) => {
          stepCounter = steps.length;

          if (productInfo["builder[quantity]"] > 1) {
            if (product == "A" && index === 4) {
              stepCounter = 4;
              return null;
            } else if (product == "W" && index === 3) {
              stepCounter = 3;
              return null;
            }
          }

          if (productInfo["complex[1][band][material]"] === "STR") {
            if (product == "A" && (index === 3 || index === 4)) {
              stepCounter = 3;
              return null;
            } else if (product == "W" && (index === 2 || index === 3)) {
              stepCounter = 2;
              return null;
            }
          }

          return (
            <Step key={index}>
              <StepLabel
                StepIconComponent={CustomStepIcon}
                onClick={() => handleStepperClick(index)}
                sx={{ cursor: "pointer" }}
                optional={
                  completedSteps.has(index) ? (
                    <Typography variant="subtitle2" color="text.secondary">
                      {(index == 3 && !setting.style) ||
                      (index == 4 && !diamondSelected)
                        ? "None Selected"
                        : Object.entries(fieldSelected[index])
                            .map(([key, value]) => `${key}: ${value}`)
                            .join(", ")}
                    </Typography>
                  ) : null
                }
              >
                <Typography
                  sx={{
                    fontFamily: theme.typography.body1,
                    fontWeight: "bold",
                  }}
                >
                  {label}
                </Typography>
              </StepLabel>
              <StepContent>
                {renderStepContent(index)}
                <Stack direction="row" gap={2}>
                  <Button
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1 }}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 1 }}
                    disabled={
                      (product == "A"
                        ? index == 3 && !setting.style
                        : index == 2 && !setting.style) ||
                      (product == "A"
                        ? index == 3 && productInfo["builder[quantity]"] != 1
                        : index == 2 && productInfo["builder[quantity]"] != 1)
                    }
                  >
                    {index === stepCounter - 1 ? "Finish" : "Next"}
                  </Button>
                </Stack>
              </StepContent>
            </Step>
          );
        })}
      </Stepper>
      {activeBandStep === steps.length && (
        <Box sx={{ mt: 4 }}>
          <Stack spacing={2}>
            <Typography variant="h6">All steps completed!</Typography>
            <Button onClick={handleReset} variant="contained">
              Restart
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
}

export default BandStepper;
